import { graphql, rest, setupWorker, SetupWorker } from 'msw'
import { GraphQLHandlerData, RestHandlerData } from './types'
import buildHandlersContext from './handlers'

export interface ExtendedWorker extends SetupWorker {
    recreateHandlers(graphqlHandlerData: GraphQLHandlerData[], restHandlerData: RestHandlerData[]): void
}

const createWorker = () => {
    const worker = setupWorker() as ExtendedWorker

    worker.recreateHandlers = function recreateHandlers(
        graphqlData: GraphQLHandlerData[],
        restHandlerData: RestHandlerData[]
    ): void {
        const buildgraphQLHandlers = () => {
            return graphqlData.map((q) => {
                if (q.type === 'QUERY') return graphql.query(q.name, (req, res, ctx) => res(ctx.data(q.data)))
                return graphql.mutation(q.name, (req, res, ctx) => res(ctx.data(q.data)))
            })
        }

        const buildRestHandlers = () => {
            return restHandlerData.map((q) => {
                if (q.method === 'POST') return rest.post(q.url, (req, res, ctx) => res(ctx.json(q.response)))
                // get for now extend if needed (path put etc)
                return rest.get(q.url, (req, res, ctx) => res(ctx.json(q.response)))
            })
        }

        this.resetHandlers(...buildgraphQLHandlers(), ...buildRestHandlers())
    }

    // Set default handlers the first time (on creation)
    const { rawHandlerDataGraphql, rawHandlerDataRest } = buildHandlersContext()
    worker.recreateHandlers(rawHandlerDataGraphql, rawHandlerDataRest)

    return worker
}

export default createWorker
